import React from "react";

const QuotationTerms = ({ quotation }) => {
  if (!quotation?.terms) {
    return null;
  }

  return (
    <section className="quotation-card">
      <h2>Terms & Conditions</h2>

      <p className="terms-text">{quotation.terms}</p>
    </section>
  );
};

export default QuotationTerms;